import "./App.css";
import AppRoutes from "./appRoutes";

function App() {
  return (
    <div className="h-screen relative">
      <AppRoutes />
    </div>
  );
}

export default App;
